import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { AdiantamentoFolha } from 'src/app/admihair/api/dto/adiantamento-folha';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { AdiantamentoFolhaService } from 'src/app/admihair/service/adiantamento-folha.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-adiantamento-inserir',
  templateUrl: './adiantamento-inserir.component.html',
  styleUrls: ['./adiantamento-inserir.component.scss']
})
export class AdiantamentoInserirComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;
  tiposPagamento: TipoPagamento[] = [];
  funcionarios: Profissional[] = [];
  qtdParcelas: number = 1;
  dataRegistro: Date = new Date();
  dataCob: Date = new Date();
  valorDigitado: number = 0;
  exibirMensagemValor: boolean = false;
  @ViewChild('f') formulario?: NgForm;

  constructor(private adiantamentoFolhaService: AdiantamentoFolhaService,
    private tipoPagamentoService: TipoPagamentoService,
    private profissionalService: ProfissionalService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService,
  ) { }

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_ADIANTAMENTO_FOLHA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.carregarTiposPagamento();
      this.carregarProfissionais();
    }
  }

  salvar(){
    this.progressoRequisicao = true;
    const adiantamento: AdiantamentoFolha = this.formulario?.form.value;
    adiantamento.empresaId = this.empresaSelecionada?.id;
    adiantamento.operador = this.utilStorageService.getUser().usuario.id;
    this.adiantamentoFolhaService.salvar(adiantamento).subscribe({
      next: (data: AdiantamentoFolha) => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso()
        this.limparFormulario();
      },
      error: (err: any) => {
        this.exibirMensagemValor = true;
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    })


  }

  carregarProfissionais(){
    this.profissionalService.listarAtivosPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Profissional[]) => {
        this.funcionarios = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  carregarTiposPagamento(){
    this.tipoPagamentoService.listarPorEmpresaEOperacaoInterno(this.empresaSelecionada?.id).subscribe({
      next: (data: TipoPagamento[]) => {
        this.tiposPagamento = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  alterarExibirMensagemValor() {
    this.exibirMensagemValor = true;
  }


  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  limparFormulario(){
    this.form?.reset();
    this.exibirMensagemValor = false;
    this.valorDigitado = 0;
    this.qtdParcelas = 1;
    this.dataRegistro = new Date();
    this.dataCob = new Date();
  }

  exibirMensagemSucesso() {
    this.messages = this.erroService.handleSuccess();
    this.messagemVisivel = true;
    this.rolarTela();
  }

  exibirMensagemErro(err: any) {
    this.messages = this.erroService.handleErro(err);
    this.messagemVisivel = true;
    this.rolarTela();
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
